module.exports = __webpack_public_path__ + "img/rejectbg.fa1ec189.jpg";